import React, { Suspense, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import { SwiperButtonNext } from "../../components/button/SwiperButton";
import axios from "axios";
import "./LandingSection.css";

// import SmartCityImage from '../../assets/images/SVG/home-illlustration.svg'
import SplineScene from "../../assets/Spline/scene.splinecode";

// import Spline from '@splinetool/react-spline';
const Spline = React.lazy(() => import("@splinetool/react-spline"));

function LandingSection() {
  const [email, setEmail] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const [name, setName] = useState("");
  const [nameValid, setNameValid] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneValid, setPhoneValid] = useState(false);
  const navigate = useNavigate();

  function validateEmailInterceptor(e) {
    setEmail(e.target.value);
    var filter =
      /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    let pass = String(e.target.value).search(filter) != -1;
    if (pass) {
      setEmailValid(true);
      return true;
    } else {
      setEmailValid(false);
      return false;
    }
  }
  function validateNameInterceptor(e) {
    setName(e.target.value);

    if (e.target.value.length > 3) {
      setNameValid(true);
      return true;
    } else {
      setNameValid(false);
      return false;
    }
  }
  function validatePhone(e) {
    setPhone(e.target.value);
    if (String(e.target.value).length == 10) {
      setPhoneValid(true);
    } else {
      setPhoneValid(false);
      return false;
    }
  }

  function submit() {
    if (emailValid && nameValid && phoneValid) {
      axios
        .post("https://submit-form.com/iapMVxvl", {
          email,
          name,
          phone,
        })
        .then(function (response) {
          navigate("/success");
        })
        .catch(function (response) {
          alert("Form not submitted. Please check internet connection.");
        });
    } else if (!phoneValid) {
      alert("10 digit dialing");
    }
  }

  return (
    <div className="landing-section">
      <section className="landing-page-tagline">
        <div className="landing-page-cont">
          <div className="landing-section-main-text-cont">
            <h1 className="landing-section-main-text">
              Take Control of Your Airbnb business
            </h1>
            <div className="early-access-info-cont">
              <p className="landing-section-secondary-text">
                Take care of self-check-ins and smart airbnb management while
                guess focuses on relaxing
              </p>
              <div className="landing-page-input-container">
                <div className="swiper_container">
                  <Swiper
                    spaceBetween={50}
                    slidesPerView={1}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    allowTouchMove={false}
                  >
                    <SwiperSlide>
                      {" "}
                      <div className="input__wrap">
                        <input
                          type="email"
                          placeholder="Your email..."
                          onChange={(e) => {
                            validateEmailInterceptor(e);
                          }}
                          required
                        />

                        {emailValid ? (
                          <SwiperButtonNext text="Request Early Access" />
                        ) : (
                          <button
                            onClick={() => {
                              alert("Valid Email Required");
                            }}
                          >
                            Request Early Access
                          </button>
                        )}
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      {" "}
                      <div className="input__wrap">
                        <input
                          className="email__input"
                          type="text"
                          placeholder="Your Full Name..."
                          onChange={(e) => {
                            validateNameInterceptor(e);
                          }}
                          required
                        />
                        {nameValid ? (
                          <SwiperButtonNext text="Next" />
                        ) : (
                          <button
                            onClick={() => {
                              alert("Full Name Required");
                            }}
                          >
                            Next
                          </button>
                        )}
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      {" "}
                      <div className="input__wrap">
                        <input
                          className="email__input"
                          type="number"
                          placeholder="Your Phone Number..."
                          onChange={(e) => {
                            validatePhone(e);
                          }}
                          required
                        />
                        <button
                          onClick={() => {
                            submit();
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
          <div className="spline-wrapper">
            <Suspense
              fallback={<div style={{ color: "white" }}>Loading...</div>}
            >
              <Spline
                className="spline"
                scene={SplineScene}
                onLoad={() => console.log("Spline loaded")}
              />
            </Suspense>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LandingSection;
